import { GANHE_MAIS_CORRETOR_CLIENT_URL } from '../../constants/ClientUrls';
import { HOME_EQUITY } from '../../constants/Routes';
import styles from './style.module.css';
import imageLoading from '../../assets/images/logo-light.png';
import imageGanheMaisCorretor from '../../assets/images/ganhemaiscorretor-logo.png';
import { getUrlClient } from '../../utils/getUrlClient';
import { decodeSafedata } from '../../utils/decodeSafeData';

function isGanheMaisCorretorClient(): boolean {
  if (getUrlClient().link === GANHE_MAIS_CORRETOR_CLIENT_URL) return true;

  try {
    const raw = localStorage.getItem('@pwa:client');
    if (!raw) return false;
    const decoded = decodeSafedata(raw);
    if (!decoded) return false;
    const clientData = JSON.parse(JSON.parse(decoded));
    return clientData?.clientUrl === GANHE_MAIS_CORRETOR_CLIENT_URL;
  } catch {
    return false;
  }
}

function isSharedHomeEquityPage(): boolean {
  const [, base, first, second] = window.location.pathname.split('/');
  return (
    `/${base}` === HOME_EQUITY && !!first && first !== 'details' && !!second
  );
}

export function Loading() {
  if (isSharedHomeEquityPage()) {
    return (
      <div className={styles.loadingNeutral}>
        <div className="spinner-border" role="status">
          <span className="visually-hidden">Carregando...</span>
        </div>
      </div>
    );
  }

  if (isGanheMaisCorretorClient()) {
    return (
      <div className={styles.loadingGanheMaisCorretor}>
        <img
          className={styles.gmpulse}
          src={imageGanheMaisCorretor}
          alt="Logo loading"
        />
      </div>
    );
  }

  return (
    <div className={styles.loading}>
      <img className={styles.heartbeat} src={imageLoading} alt="Logo loading" />
    </div>
  );
}
